function filterSelection(category, clickedButton = null) {
  const buttons = document.querySelectorAll("#myBtnContainer .btn");
  buttons.forEach(btn => btn.classList.remove("active"));
  if (clickedButton) clickedButton.classList.add("active");

  const dropdown = document.getElementById("filterDropdown");
  if (dropdown) dropdown.value = category;

  const items = document.getElementsByClassName("filterDiv");
  const categoryClass = category === "all" ? "" : category;

  for (let i = 0; i < items.length; i++) {
    faqRemoveClass(items[i], "show");
    if (items[i].className.indexOf(categoryClass) > -1 || categoryClass === "") {
      faqAddClass(items[i], "show");
    }
  }
}

function syncWithButtons(selectElement) {
  const selectedValue = selectElement.value;
  const buttons = document.querySelectorAll("#myBtnContainer .btn");
  buttons.forEach(btn => {
    btn.classList.toggle("active", btn.dataset.category === selectedValue);
  });
  filterSelection(selectedValue);
}

function searchFunction() {
  const input = document.getElementById('myInput');
  const filter = input.value.toUpperCase();
  const ul = document.querySelector(".myUL");
  if (!ul) return;
  const li = ul.getElementsByTagName('li');

  for (let i = 0; i < li.length; i++) {
    const p = li[i].querySelector("p");
    const s = li[i].querySelector("span");
    const txtValue = ((s?.textContent || "") + " " + (p?.textContent || "")).toUpperCase();
    li[i].style.display = txtValue.indexOf(filter) > -1 ? "" : "none";
  }
}

function faqAddClass(element, name) {
  const arr1 = element.className.split(" ");
  const arr2 = name.split(" ");
  arr2.forEach(n => {
    if (!arr1.includes(n)) element.className += " " + n;
  });
}

function faqRemoveClass(element, name) {
  let arr1 = element.className.split(" ");
  const arr2 = name.split(" ");
  arr2.forEach(n => {
    while (arr1.includes(n)) arr1.splice(arr1.indexOf(n), 1);
  });
  element.className = arr1.join(" ");
}

document.addEventListener("DOMContentLoaded", function () {
  // Accordion animation
  function slideDown(el, duration = 300) {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.offsetHeight;
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = height + 'px';
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, duration);
  }

  function slideUp(el, duration = 300) {
    el.style.height = el.offsetHeight + 'px';
    el.style.overflow = 'hidden';
    el.offsetHeight;
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = 0;
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, duration);
  }

  const activeTabs = document.querySelectorAll(".tab.is-active .accordion-panel");
  activeTabs.forEach(panel => panel.style.display = "block");

  document.querySelectorAll(".myUL .tab span.accordion-thumb").forEach(span => {
    span.addEventListener("click", function (e) {
      e.preventDefault();
      const currentTab = this.closest(".tab");
      if (!currentTab) return;
      const currentPanel = currentTab.querySelector(".accordion-panel");
      if (!currentPanel) return;

      document.querySelectorAll(".tab").forEach(tab => {
        if (tab !== currentTab) {
          tab.classList.remove("is-active");
          const panel = tab.querySelector(".accordion-panel");
          if (panel) slideUp(panel);
        }
      });

      if (currentTab.classList.contains("is-active")) {
        currentTab.classList.remove("is-active");
        slideUp(currentPanel);
      } else {
        currentTab.classList.add("is-active");
        slideDown(currentPanel);
      }
    });
  });

  // Fallback event binding
  document.querySelectorAll("#myBtnContainer .btn").forEach(btn => {
    btn.addEventListener("click", function () {
      filterSelection(this.dataset.category, this);
    });
  });

  // Default filter
    if (document.body.classList.contains("gift-card")) {
      filterSelection("returnpolicies");
    } else {
      filterSelection("all");
    }

});


  document.addEventListener("DOMContentLoaded", function () {
    var firstBtn = document.querySelector("#myBtnContainer .btn:first-child");
    if (firstBtn) {
      firstBtn.classList.add("active");
    }
  });